module.exports = __webpack_public_path__ + "img/android.15093299.png";